import React, { Suspense, lazy } from 'react';
import { Loader2 } from 'lucide-react';

// Iter 76 (2026-06-07) — V3 legacy layout (MainAppLegacy.js) removed.
// V4 (Soft Clay) is now the only layout. `classic_stack_enabled` and
// `ui_v4_enabled` toggles kept in DB for emergency rollback only — admins
// can no longer change them from the UI.
const MainApp = lazy(() => import(/* webpackChunkName: "main-app" */ './MainApp'));

function LayoutSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <Loader2 className="w-6 h-6 animate-spin text-indigo-500" />
    </div>
  );
}

export default function MainAppRouter() {
  return (
    <Suspense fallback={<LayoutSpinner />}>
      <MainApp />
    </Suspense>
  );
}
